import { render, staticRenderFns } from "./LiCoin.vue?vue&type=template&id=9c3af7d4&scoped=true"
import script from "./LiCoin.vue?vue&type=script&lang=js"
export * from "./LiCoin.vue?vue&type=script&lang=js"
import style0 from "./LiCoin.vue?vue&type=style&index=0&id=9c3af7d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c3af7d4",
  null
  
)

export default component.exports